import React from "react";
import { useLang } from "../../contexts/LanguageContext";
import Reveal from "../Reveal";

export default function Model() {
  const { t } = useLang();
  const c = t.model;
  return (
    <section id="modelo" data-testid="model-section" className="py-24 sm:py-32 bg-olive text-ivory">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
        <div className="grid grid-cols-12 gap-y-10 gap-x-6 mb-16">
          <Reveal className="col-span-12 lg:col-span-3 flex items-start gap-4">
            <span className="block h-px w-12 bg-terracotta mt-3" aria-hidden />
            <span className="eyebrow">{c.eyebrow}</span>
          </Reveal>
          <Reveal as="h2" className="col-span-12 lg:col-span-9 h-section">
            {c.title}
          </Reveal>
          {c.lede && (
            <Reveal className="col-span-12 lg:col-span-8 lg:col-start-4">
              <p className="text-lg text-ivory/80 leading-relaxed font-serif italic">{c.lede}</p>
            </Reveal>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-ivory/15 mb-16">
          {c.items.map((it, i) => (
            <Reveal key={i} delay={i * 70} data-testid={`model-card-${i}`} className="bg-olive p-8 sm:p-10 flex flex-col gap-5">
              <div className="font-mono text-[10px] tracking-[0.35em] uppercase text-terracotta">{it.tag}</div>
              <p className="font-serif text-2xl sm:text-3xl leading-snug">{it.body}</p>
            </Reveal>
          ))}
        </div>

        {c.snapshot && (
          <div className="mb-16">
            <Reveal className="font-mono text-[10px] tracking-[0.35em] uppercase text-terracotta mb-6">
              {c.snapshotTitle}
            </Reveal>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-ivory/15 border border-ivory/15">
              {c.snapshot.map((s, i) => (
                <Reveal key={i} delay={i * 50} data-testid={`model-snapshot-${i}`} className="bg-olive p-6 flex flex-col gap-2">
                  <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-ivory/60">{s.tag}</div>
                  <div className="flex items-baseline gap-2 flex-wrap">
                    <span className="font-display text-4xl text-ivory leading-none">{s.value}</span>
                    {s.unit && <span className="font-mono text-[10px] tracking-[0.18em] uppercase text-terracotta">{s.unit}</span>}
                  </div>
                  {s.note && <p className="text-sm text-ivory/70 italic font-serif leading-snug mt-2">{s.note}</p>}
                </Reveal>
              ))}
            </div>
            {c.snapshotDisclaimer && (
              <Reveal>
                <p className="mt-6 border-l-2 border-terracotta pl-5 py-1 text-sm text-ivory/80 italic font-serif">
                  {c.snapshotDisclaimer}
                </p>
              </Reveal>
            )}
          </div>
        )}

        {c.disclaimers && (
          <Reveal>
            <div className="border-t border-ivory/20 pt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-5">
              {c.disclaimers.map((d, i) => (
                <div key={i} data-testid={`model-disclaimer-${i}`} className="flex flex-col gap-2">
                  <span className="font-mono text-[10px] tracking-[0.35em] uppercase text-terracotta">{d.tag}</span>
                  <p className="text-ivory/70 text-sm leading-relaxed">{d.body}</p>
                </div>
              ))}
            </div>
          </Reveal>
        )}

        <Reveal>
          <div className="mt-8 font-mono text-[10px] tracking-[0.3em] uppercase text-ivory/60">{c.note}</div>
        </Reveal>

        {c.legalDisclaimer && (
          <Reveal>
            <p data-testid="model-legal-disclaimer" className="mt-6 max-w-4xl text-sm sm:text-base text-ivory/75 leading-relaxed font-serif italic border-t border-ivory/15 pt-6">
              {c.legalDisclaimer}
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
